import { CHAT_NOTIFICATION_CATEGORIES } from "PFApp/constants/notifications";
import { selectIsChatListOpen, useChatStore, useChatStoreActions } from "PFApp/stores/chat_store";
import { useNotifications } from "PFCore/hooks/queries/notifications/use_notifications";
import { useTranslation } from "react-i18next";

import { CommonNavItemProps, NavItem } from "../parts/nav_item/nav_item";

export const ChatNavItem = (props: CommonNavItemProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "navBar.items" });

  const { data: notifications } = useNotifications({ categories: CHAT_NOTIFICATION_CATEGORIES });
  const count = notifications?.meta?.totalUnread;
  const { minimizeChat, unMinimizeChat } = useChatStoreActions();

  const isOpen = useChatStore(selectIsChatListOpen);

  return (
    <NavItem
      icon="chat"
      counter={count}
      forceOpen={isOpen}
      name={t("chat")}
      onClick={() => {
        isOpen ? minimizeChat("list") : unMinimizeChat("list");
      }}
      id="chat"
      {...props}
    />
  );
};
